export const pageKeys = {
  HOME: '2',
  AIR_LIST: '3',
  TRIP_SUMMARY: '4',
  PASSENGER_DETAILS: '5',
  PAYMENT: '6',
  TRIP_CONFIRMATION: '7',
  HOTEL_LIST: '9',
  CAR_LIST: '10',
  SEAT_SELECTION: '11',
  INVOICE_EMAIL: '12',
};
